import { withSessionToken } from './sessionToken';

const GET = 'GET';

const clientFetch = {
  /**
   * Get JSON from a resource.
   *
   * @param {Uri} uri
   * @param {AbortSignal} signal - Optional abort signal to cancel the request
   * @returns {Promise}
   */
  getJson: async (uri, signal = null) => {
    const options = { method: GET };
    if (signal) {
      options.signal = signal;
    }
    const response = await fetch(uri.toString(), options);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  },

  /**
   * Get JSON from a resource via proxy.
   *
   * @param {Uri} uri
   * @param {string} baseUrl
   * @param {boolean} addHrefHeader
   * @param {AbortSignal} signal - Optional abort signal to cancel the request
   * @returns {Promise}
   */
  getJsonByProxy: async (uri, baseUrl, addHrefHeader = false, signal = null) => {
    const url = `${baseUrl}/api/proxy?url=${encodeURIComponent(uri.toString())}`;
    const headers = {};
    if (addHrefHeader) {
      headers['x-location-href'] = window.location.href;
    }
    const options = {
      method: GET,
      headers: withSessionToken(headers),
    };
    if (signal) {
      options.signal = signal;
    }
    const response = await fetch(url, options);
    if (!response.ok) {
      const error = new Error(`HTTP error! status: ${response.status}`);
      error.status = response.status;
      throw error;
    }
    return response.json();
  },
};

export default clientFetch;
